(function () {
  // Ensure Elevar data layer exists
  window.ElevarDataLayer = window.ElevarDataLayer || [];

  // Ensure Okendo connect API exists
  window.okeConnectApi = window.okeConnectApi || {};

  // 🔒 Guard to prevent double-firing
  var quizEventFired = false;

  var previous = window.okeConnectApi.recommendedProductsMounted;

  window.okeConnectApi.recommendedProductsMounted = function () {
    // Stop if already fired
    if (quizEventFired) return;

    quizEventFired = true;

    // ✅ FIRE ELEVAR EVENT ONCE
    window.ElevarDataLayer.push({
      event: "dl_complete_quiz",
      event_properties: {
        quiz_result: "result"
      }
    });

    console.log("quiz submited");

    // Call any existing handler
    if (typeof previous === "function") {
      return previous.apply(this, arguments);
    }
  };
})();
